export interface DefaultSuccess<T = unknown> {
  code?: 200;
  message?: 'success';
  data: T;
}
export interface AdressBoookConfig {
  companyId: string;
  enabled: number;
  configuration: string;
}

export enum LoadingStatus {
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected'
}

export type Loading = '' | 'pending' | 'fulfilled' | 'rejected';
